module.exports = __webpack_public_path__ + "img/IT0000161337208.19468400.png";